import { css } from '@emotion/react';
import { N20, N100, N700 } from '@atlaskit/theme/colors';
export const buttonGroupStyles = css`
  display: flex;
  align-items: center;
  p {
    margin-right: ${"var(--ds-space-050, 4px)"};
  }
`;
export const buttonStyles = isSelected => css`
  svg {
    color: ${isSelected ? `var(--ds-icon-selected, ${N20})` : `var(--ds-icon-accent-gray, ${N100})`};
  }
  ${isSelected ? `&[disabled] {
        background-color: ${`var(--ds-background-selected, ${N700})`};
      }` : ''}
`;
export const dislikeButtonStyles = css`
  transform: rotate(180deg);
`;